import { favoriteComposerService, type FavoriteComposer } from './favoriteComposers';

import type { LibraryComposer } from '../interfaces/composer';

const stubComposers: LibraryComposer[] = [
  {
    id: 'cmf-composer-bach',
    spotifyArtistId: '5aIqB5nVVvmFsvSdExz408',
    uri: 'spotify:artist:5aIqB5nVVvmFsvSdExz408',
    type: 'composer',
    name: 'Johann Sebastian Bach',
    imageUrl: 'https://i.scdn.co/image/ab6761610000e5eb830c172d555a63ec6d17a87f',
    era: 'Baroque',
    birthYear: '1685',
    deathYear: '1750',
    summary: 'Cantor of Leipzig, famed for his sacred music and intricate counterpoint.',
  },
  {
    id: 'cmf-composer-beethoven',
    spotifyArtistId: '2wOqMjp9TyABvtHdOSOTUS',
    uri: 'spotify:artist:2wOqMjp9TyABvtHdOSOTUS',
    type: 'composer',
    name: 'Ludwig van Beethoven',
    imageUrl: 'https://i.scdn.co/image/ab6761610000e5eba4721517972ed18f5d9413a4',
    era: 'Classical / Early Romantic',
    birthYear: '1770',
    deathYear: '1827',
    summary: 'Bridged the Classical and Romantic eras with symphonies of unprecedented scope.',
  },
  {
    id: 'cmf-composer-holst',
    spotifyArtistId: '3MKCzCnpzw3TjUYs2v7vDA',
    uri: 'spotify:artist:3MKCzCnpzw3TjUYs2v7vDA',
    type: 'composer',
    name: 'Gustav Holst',
    imageUrl: 'https://i.scdn.co/image/ab6761610000e5ebb91604320f27463e99e36fc5',
    era: '20th Century',
    birthYear: '1874',
    deathYear: '1934',
    summary: 'English composer best known for The Planets and innovative choral writing.',
  },
];

const normalizeComposer = (favorite: FavoriteComposer): LibraryComposer => {
  const savedAt = favorite.savedAt ?? new Date().toISOString();
  const spotifyArtistId = favorite.spotifyArtistId ?? undefined;
  const id = favorite.composerId ?? spotifyArtistId ?? favorite.name ?? `composer-${savedAt}`;
  return {
    id: String(id),
    spotifyArtistId,
    uri: favorite.uri ?? (spotifyArtistId ? `spotify:artist:${spotifyArtistId}` : `cmf:composer:${id}`),
    type: 'composer',
    name: favorite.name ?? favorite.composerId ?? 'Unknown Composer',
    imageUrl: favorite.imageUrl ?? undefined,
    era: favorite.era ?? undefined,
    birthYear: favorite.birthYear ?? undefined,
    deathYear: favorite.deathYear ?? undefined,
    savedAt,
  };
};

const fetchComposers = async (): Promise<LibraryComposer[]> => {
  try {
    const favorites = await favoriteComposerService.getFavoriteComposers();
    if (!favorites.length) {
      return [];
    }
    return favorites.map(normalizeComposer);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('[libraryService] Falling back to stub composers', error);
    }
    return stubComposers;
  }
};

export const libraryService = {
  fetchComposers,
};
